export enum StructCapCrmStatusReason {
  RA_PASS = 'RA_PASS',
  LOST_DEAL = 'LOST_DEAL',
  ALTERNATIVE_DEAL = 'ALTERNATIVE_DEAL',
  NO_TRANSACTION = 'NO_TRANSACTION',
  OTHER = 'OTHER'
}

export const StructCapCrmStatusReasonLabels: Record<StructCapCrmStatusReason, string> = {
  [StructCapCrmStatusReason.RA_PASS]: 'RA Pass',
  [StructCapCrmStatusReason.LOST_DEAL]: 'Lost Deal',
  [StructCapCrmStatusReason.ALTERNATIVE_DEAL]: 'Alternative Deal',
  [StructCapCrmStatusReason.NO_TRANSACTION]: 'No Transaction',
  [StructCapCrmStatusReason.OTHER]: 'Other',
};
